import { isNumber, equalNumbers } from "./functions"

export const compareNumbers = (numberDataBase: string, numberUser: string) => {

    const numero = numberDataBase.replace(/ /g,'').replace(/inf/g,'1e309');
    const numeroUsuario = numberUser.replace(/ /g,'').replace(/inf/g,'1e309');

    if (numeroUsuario === '') {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'No has ingresado una respuesta'
        }
    }

    if (!isNumber(numeroUsuario).ok) {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa un número'
        }
    }

    if (!equalNumbers(numero,numeroUsuario).ok) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la solución'
        }
    }

    return { 
        ok: true, 
        title: '¡Felicitaciones!',
        msg: 'Has encontrado la solución'
    }
}
